import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "reactstrap";
import {
  ContactAddress,
  ContactContactName,
  ContactEmail,
  ContactLanguage,
  ContactMobile,
  ContactPhone,
  ContactTimeZone,
  ContactTitle,
  ContactWebsite,
} from "src/shared/contacts/formatters/ContactFormatters";
import type { Contact } from "src/shared/contacts/objects/Contact";

export interface IContactDetailsProps {
  contact: Contact;
  className?: string;
  children?: ReactNode;
  bottomSection?: ReactNode;
  isCopyable?: boolean;
}

export const ContactDetails = ({
  contact,
  className,
  bottomSection,
  isCopyable,
  children,
}: IContactDetailsProps) => (
  <>
    <Row tag="dl" className={className}>
      {children}

      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.address" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactAddress isCopyable={isCopyable}>{contact}</ContactAddress>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.website" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactWebsite isCopyable={isCopyable}>{contact}</ContactWebsite>
      </Col>

      {contact.timeZone && (
        <>
          <Col sm={4} tag="dt">
            <FormattedMessage id="contacts.timezone" />
          </Col>
          <Col sm={8} tag="dd">
            <ContactTimeZone>{contact}</ContactTimeZone>
          </Col>
        </>
      )}

      {contact.languageCode && (
        <>
          <Col sm={4} tag="dt">
            <FormattedMessage id="contacts.language" />
          </Col>
          <Col sm={8} tag="dd">
            <ContactLanguage>{contact}</ContactLanguage>
          </Col>
        </>
      )}

      {bottomSection}
    </Row>

    <hr />

    <Row tag="dl" className={className}>
      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.name" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactContactName isCopyable={isCopyable}>
          {contact}
        </ContactContactName>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.title" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactTitle isCopyable={isCopyable}>{contact}</ContactTitle>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.email" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactEmail isCopyable={isCopyable}>{contact}</ContactEmail>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.phone_no" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactPhone isCopyable={isCopyable}>{contact}</ContactPhone>
      </Col>

      <Col sm={4} tag="dt">
        <FormattedMessage id="contacts.mobile_no" />
      </Col>
      <Col sm={8} tag="dd">
        <ContactMobile isCopyable={isCopyable}>{contact}</ContactMobile>
      </Col>
    </Row>
  </>
);
